import {treeAspect, wikiTab, isRootDomainConfig, isDomainRecord} from './utils'
export {sys} from './sysviews'

//~ export const title = {
//~ layout: 'L131',
//~ acl: 'g:admin',
//~ filters: [{cacheKeys: ['dname', 'id'], type: 'ancestorAxisJson'}],
//~ tabs: {
//~ id: {
//~ parts: [{type: 'Metadata', filters: ['getModsRendered']}],
//~ },
//~ struct: {
//~ parts: [{type: 'TableOfContents', filters: ['structuredImageLocationsJson']}],
//~ },
//~ },
//~ }

export const proto = {
  parts: ['ProtoHeader'],
  layout: 'blank',
  default: true, // index page
  tabs: {
    home: {
      default: true,
      parts: [
        {
          type: 'Wikiblock',
          name: 'CenterWiki',
          filters: [{ident: 'home', type: 'getWikiRendered'}],
        },
      ],
    },
    viewer: {
      parts: [
        {
          type: 'ViewerGrid',
          optionSet: 'simple',
          style: 'overflow:auto',
          filters: ['structuredImageLocationsJson'],
        },
      ],
      layout: 'L1',
    },
    viewer2: {
      parts: [{type: 'SwiperViewer', filters: ['structuredImageLocationsJson']}],
      layout: 'L1',
    },
    search: {
      parts: [
        {
          type: 'SearchResult',
          align: 'center',
          filters: [{lazy: true, part: 'SearchResult', type: 'getQuickSearchResult'}],
        },
      ],
    },
    wiki: {
      parts: [
        {
          type: 'Wikiblock',
          name: 'CenterWiki',
          filters: [{type: 'ancestorAxisJson', cacheKeys: ['dname', 'id']}, 'getWikiRendered'],
        },
      ],
    },
  },
}
